import type { AppLocale } from '@/shared/configs/app.config';

/**
 * Per-locale URL of the SIP 3-year-warranty marketing page on sip.si.
 * Any locale without a dedicated page falls back to {@link FALLBACK_WARRANTY_URL}.
 */
const FALLBACK_WARRANTY_URL = 'https://www.sip.si/en/sales/3-year-sip-warranty/';

const warrantyUrls: Record<AppLocale, string> = {
  sl: 'https://www.sip.si/prodaja/sip-3-letna-garancija/',
  en: FALLBACK_WARRANTY_URL,
  de: 'https://www.sip.si/de/verkauf/sip-3-jahre-garantie/',
  hr: 'https://www.sip.si/hr/prodaja/3-godine-sip-jamstva/',
  it: 'https://www.sip.si/it/vendite/garanzia-sip-di-3-anni/',
  fr: 'https://www.sip.si/fr/ventes/garantie-sip-de-3-ans/',
  pl: 'https://www.sip.si/pl/sprzedaz/3-letnia-gwarancja-sip/',
  et: 'https://www.sip.si/et/muuk/3-aastane-sip-garantii/',
  es: 'https://www.sip.si/es/ventas/3-anos-de-garantia-sip/',
  cs: 'https://www.sip.si/cs/prodej/3leta-zaruka-sip/',
  fi: 'https://www.sip.si/fi/myynti/3-vuoden-sip-takuu/',
  hu: 'https://www.sip.si/hu/ertekesites/sip-3-ev-garancia/',
  da: 'https://www.sip.si/da/salg/3-ars-sip-garanti/',
};

/**
 * Resolves the active locale to its SIP 3-year-warranty page URL.
 * Pure function: unmapped or unknown locales fall back to the English page.
 */
export const resolveWarrantyUrl = (locale: string): string =>
  warrantyUrls[locale as AppLocale] ?? FALLBACK_WARRANTY_URL;
